<template>
  <div class="cart-icon" @click="goToCart">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="9" cy="21" r="1"></circle>
      <circle cx="20" cy="21" r="1"></circle>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
    <span v-if="cartItemCount > 0" class="cart-badge">{{ cartItemCount }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CartIcon',
  computed: {
    ...mapGetters(['cartItemCount'])
  },
  methods: {
    goToCart () {
      if (this.cartItemCount === 0) {
        this.$router.push('/shop')
      } else {
        this.$router.push('/cart')
      }
    }
  }
}
</script>

<style scoped>
.cart-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 9px 10px 0 0;
  float: right;
  cursor: pointer;
  transition: opacity 0.2s;
}

.cart-icon:hover {
  opacity: 0.7;
}

.cart-icon svg {
  color: #cbd5e0;
  stroke-width: 2;
}

.cart-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #e53e3e;
  color: white;
  font-size: 10px;
  font-weight: bold;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// CartIcon.vue?6c3bf73c